module.exports = __webpack_public_path__ + "img/dp-exclusive.ee73deec.png";